module.exports = __webpack_public_path__ + "img/icon_binoculars.bc405a79.svg";